import { TimecardModelBase }          from '../../timecard/TimecardModel';
import { OtherPaymentsModelBase }     from '../../timecard/OtherPaymentsModel';
import timecardTestEditTimecardsModel from './TimecardTestEditTimecardsModel';

export class TimecardTestOtherPaymentsModel extends OtherPaymentsModelBase {
  constructor() {
    super();
  }

  get timecardModel(): TimecardModelBase {
    return timecardTestEditTimecardsModel;
  }
}

const timecardTestOtherPaymentsModel = new TimecardTestOtherPaymentsModel();
export default timecardTestOtherPaymentsModel;
